import Model from './model.js';

export default class JobRecord extends Model
{
    constructor(id, personId, institution, workPlace, jobTitle, position, dateAppointment, type, note){ 
        super()
        this.id                 = id ?? 0;
        this.personId           = personId;
        this.institution        = institution;
        this.workPlace          = workPlace;
        this.jobTitle           = jobTitle;
        this.position           = position;
        this.dateAppointment    = dateAppointment;
        this.type               = type;
        this.note               = note;

        this.init()
    }

    update(data){
        Object.assign(this, data)
    }

    mapToUpdate(){
        const type = Number(this.type?.value ?? 0)

        let data =  {
            jobTitle:           this.jobTitle ?? null,
            position:           this.position ?? null,
            dateAppointment:    this.dateAppointment ?? null,
            type:               this.type?.value ?? null,
            notes:              this.note ?? null,
            institutionId:      type == 1 ? (this.institution?.value ?? null) : null,
            workPlace:          type == 2 ? (this.workPlace ?? null) : null,
        }
        return data;
    }
    
    mapToCreate(){
        const type = Number(this.type?.value ?? 0)

        let data =  {
            jobTitle:           this.jobTitle ?? null,
            position:           this.position ?? null,
            dateAppointment:    this.dateAppointment ?? null,
            type:               this.type?.value ?? null,
            notes:              this.note ?? null,
            institution_id:     type == 1 ? (this.institution?.value ?? null) : null,
            workPlace:          type == 2 ? (this.workPlace ?? null) : null,
        }
        data.personId = this.personId ?? null;
        return data;
    }
}

